import { render } from "./Viewer.vue?vue&type=template&id=0d7b7001"
import script from "./Viewer.vue?vue&type=script&lang=js"
export * from "./Viewer.vue?vue&type=script&lang=js"

import exportComponent from "C:\\VS2022\\kirchenbote-online-2022_01\\MD.RMP.KirchenboteOnline.Umb\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/js/multiPaper/Viewer.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0d7b7001"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0d7b7001', __exports__)) {
    api.reload('0d7b7001', __exports__)
  }
  
  module.hot.accept("./Viewer.vue?vue&type=template&id=0d7b7001", () => {
    api.rerender('0d7b7001', render)
  })

}


export default __exports__